import React, { useMemo, useState } from 'react';
import useFonts from '../hooks/useFonts';
import FontPickerModal from './FontPickerModal';
import '../styles/font-picker.css';

export default function FontPicker({
  label = 'Fonte',
  value,
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const {
    fonts,
    loading,
    error,
    searchQuery,
    searchFonts,
    category,
    setCategory,
    selectedFont,
    selectedWeight,
    selectedFontData,
    setSelectedWeight,
    listFonts,
    selectFontFamily,
    ensureSelectedLoaded,
  } = useFonts({
    initialFamily: value?.family || 'Inter',
    initialWeight: value?.weight || '400',
  });

  const selectedFontFamily = value?.family || selectedFont;
  const selectedFontWeight = value?.weight || selectedWeight;

  const selectedFromList = useMemo(
    () => fonts.find((font) => font.family === selectedFontFamily) || fonts[0] || null,
    [fonts, selectedFontFamily]
  );

  const applySelection = (font, weight = selectedFontWeight) => {
    if (!font) return;
    selectFontFamily(font, weight);
    setSelectedWeight(String(weight));
    ensureSelectedLoaded();

    onChange?.({
      family: font.family,
      weight: String(weight || '400'),
      preview_url: font.preview_url,
      font_class: selectedFontData.font_class,
    });

    setOpen(false);
  };

  return (
    <div className="mp-font-picker">
      <button type="button" className="mp-font-picker__trigger" onClick={() => setOpen((prev) => !prev)}>
        <span>{label}</span>
        <strong>{selectedFontFamily} · {selectedFontWeight}</strong>
      </button>

      <FontPickerModal
        open={open}
        search={searchQuery}
        onSearch={(valueSearch) => searchFonts(valueSearch)}
        category={category}
        onCategoryChange={(nextCategory) => {
          setCategory(nextCategory);
          listFonts({ categoryValue: nextCategory });
        }}
        fonts={fonts}
        loading={loading}
        error={error}
        selectedFamily={selectedFontFamily}
        selectedWeight={selectedFontWeight}
        onSelectFamily={(font) => applySelection(font, selectedFontWeight)}
        onSelectWeight={(weight) => {
          setSelectedWeight(String(weight));
          if (selectedFromList) {
            applySelection(selectedFromList, weight);
          }
        }}
        onCancel={() => setOpen(false)}
        onApply={() => {
          if (selectedFromList) {
            applySelection(selectedFromList, selectedFontWeight);
          } else {
            setOpen(false);
          }
        }}
      />
    </div>
  );
}
